/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicrobiology = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.5 9.041a2.984 2.984 0 0 0-1.238.514L8.818 8.11l-.707.707 1.444 1.444A2.984 2.984 0 0 0 9.04 11.5H7v1h2.041c.077.456.256.877.514 1.238L8.11 15.182l.707.707 1.444-1.444a2.98 2.98 0 0 0 1.238.514V17h1v-2.041a2.985 2.985 0 0 0 1.238-.514l1.444 1.444.707-.707-1.444-1.444a2.98 2.98 0 0 0 .514-1.238H17v-1h-2.042a2.985 2.985 0 0 0-.513-1.238l1.444-1.444-.707-.707-1.444 1.444A2.984 2.984 0 0 0 12.5 9.04V7h-1zM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
        <path d="M8 1c.952 0 1.8.444 2.35 1.136C10.888 2.046 11.44 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.974 9.974 0 0 1 3.098-7.236A3.005 3.005 0 0 1 8 1zm0 6a2.986 2.986 0 0 1-1.75-.563A8 8 0 1 0 11 4.062 3 3 0 0 1 8 7zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMicrobiology as Microbiology };
